import {useLocation, useNavigate} from 'react-router-dom'

import menuList from './asset/menuList'
import useLogoutEvent from './model/useLogoutEvent'
import Style from './style'

import {
	ROLE_COMPETITION_MANAGER,
	ROLE_FIELD_MANAGER,
	ROLE_FRANCHISE_MANAGER,
	ROLE_STORE_MANAGER,
	ROLE_TIMER_MANAGER,
} from 'shared/constant/lookup/role'
import useLoginCookie from 'shared/model/useLoginCookie'
import useRoleCookie from 'shared/model/useRoleCookie'
import DownloadButton from 'shared/ui/DownloadButton'
import useElementSize from 'shared/hooks/useElementSize'

const Aside = ({isMobileDrawer = false, onNavigate, versionData}) => {
	const navigate = useNavigate()
	const location = useLocation()

	const [loginCookie] = useLoginCookie()
	const [roleCookie] = useRoleCookie()
	const [logoutEvent] = useLogoutEvent()

	const {ref, height} = useElementSize()
	const path = location.pathname.split('/')
	const target = path[path.length - 1]
	const deactiveList = ['qr']

	// 출력하지 않을 Router 명세
	for (let target of deactiveList) {
		if (path.includes(target)) return null
	}

	const handleNavigation = (itemPath) => {
		navigate(itemPath)
		if (onNavigate) {
			onNavigate() // Close drawer on mobile
		}
	}

	const handleLogout = () => {
		logoutEvent()
		if (onNavigate) {
			onNavigate() // Close drawer on mobile
		}
	}

	const handleEditProfile = () => {
		navigate('/admin/my/edit')
		if (onNavigate) {
			onNavigate() // Close drawer on mobile
		}
	}

	return (
		<>
			{loginCookie && target !== 'qr' && (
				<Style.Aside $isMobileDrawer={isMobileDrawer}>
					<Style.MenuList maxHeight={`${height}px`}>
						{menuList[roleCookie]?.map((category, categoryIndex) => (
							<Style.CategoryDiv key={categoryIndex}>
								<h2>{category.title}</h2>
								{category?.items.map((item, itemIndex) => (
									<Style.Element
										key={itemIndex}
										$nowPage={
											location.pathname.split('/')[1] ===
											item?.path.split('/')[1]
										}
										onClick={() => handleNavigation(item?.path)}
									>
										{item?.name}
									</Style.Element>
								))}
							</Style.CategoryDiv>
						))}
					</Style.MenuList>

					<Style.ButtonContainer ref={ref}>
						<Style.DownloadBtn
							$isLast={[
								ROLE_STORE_MANAGER,
								ROLE_FRANCHISE_MANAGER,
								ROLE_COMPETITION_MANAGER,
							].includes(roleCookie)}
						>
							<DownloadButton
								versionData={versionData}
								filename={`orcalabs-admin-v${
									versionData?.data?.version || 'latest'
								}.exe`}
							/>
						</Style.DownloadBtn>

						{![
							ROLE_STORE_MANAGER,
							ROLE_FRANCHISE_MANAGER,
							ROLE_TIMER_MANAGER,
							ROLE_FIELD_MANAGER,
						].includes(roleCookie) && (
							<Style.EditBtn onClick={handleEditProfile}>
								내 정보 수정
							</Style.EditBtn>
						)}

						<Style.LogoutBtn onClick={handleLogout}>로그아웃</Style.LogoutBtn>
					</Style.ButtonContainer>
				</Style.Aside>
			)}
		</>
	)
}

export default Aside
